export default "__VITE_ASSET__BiSGrHcw__"